/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button, Tooltip } from 'sarsaparilla';
import cx from 'classnames';
import { selectedAvailabilityCellStatuses } from '../../constants';

import { GridCell } from './Grid';

export default class AvailabilityCell extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
        className: PropTypes.string,
        tooltips: PropTypes.arrayOf(PropTypes.string),
        isSelected: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
        isBypassQuotaCheck: PropTypes.bool,
        onSelectToggle: PropTypes.func,
        screenReaderText: PropTypes.string,
        status: PropTypes.string,
    };

    render() {
        const {
            isBypassQuotaCheck,
            className,
            content,
            isSelected,
            onSelectToggle,
            tooltips,
            screenReaderText,
            status,
        } = this.props;

        // adding `,` for breaks between SR speech
        const label = tooltips.map((tooltip, i) => (
            <div className="tooltip-text" key={tooltip}>
                {tooltip}
                {i !== tooltips.length - 1 && <span className="rec-sr-only">,</span>}
            </div>
        ));
        const isAvailable = isBypassQuotaCheck || className === 'available';

        if (isSelected) {
            return (
                <GridCell
                    className={cx('selected', {
                        start: isSelected === 'AVAILABILITY_START_MULTIDAY',
                        continue: isSelected === 'AVAILABILITY_CONTINUE_MULTIDAY',
                        end: isSelected === 'AVAILABILITY_END_MULTIDAY',
                    })}
                >
                    <div className="rec-full-button-wrap">
                        <Tooltip content={label}>
                            <Button
                                className="rec-availability-date"
                                onClick={onSelectToggle}
                                aria-label={`${screenReaderText} - ${selectedAvailabilityCellStatuses[isSelected] || 'Selected'}`}
                                iconBeforeElement={<Icon iconName="check" />}
                            />
                        </Tooltip>
                    </div>
                </GridCell>
            );
        }

        return (
            <GridCell data-testid="availability-cell" className={className}>
                <div className="rec-full-button-wrap">
                    <Tooltip content={label}>
                        <Button
                            isDisabled={!isAvailable}
                            className="rec-availability-date"
                            aria-label={`${screenReaderText} - ${status}`}
                            onClick={onSelectToggle}
                        >
                            {content}
                        </Button>
                    </Tooltip>
                </div>
            </GridCell>
        );
    }
}
